import { Navigate, useParams, useRoutes } from "react-router-dom";

import CredentialsPage from "./credentials";
import DeploymentsPage from "./index";
import UsagePage from "./usage";

export default () =>
  useRoutes([
    { path: "/:deploymentId/credentials", element: <WithParameters component={CredentialsPage}/> },
    { path: "/:deploymentId/usage/api/:api", element: <WithParameters component={UsagePage}/> },
    { path: "/:deploymentId/usage/month/:ymd", element: <WithParameters component={UsagePage}/> },
    { path: "/:deploymentId/usage", element: <WithParameters component={UsagePage}/> },
    { path: "/", element: <WithParameters component={DeploymentsPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
